module.exports = __webpack_public_path__ + "static/img/cul-images2.72f0594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutImg/cul-images2.jpg
// module id = Ec51
// module chunks = 3